import { Modal, ModalProps, Switch } from 'antd';
import { useMemo, useState } from 'react';
import ProblemTable from './ProblemTable';
import { Item } from './ReviewModal';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

function ItemProblemModal({
  isVoice,
  isItemDistribution,
  isAdvantage,
  itemProblem,
  onUpdate,
  ...otherProps
}: ModalProps & {
  isVoice?: boolean;
  isItemDistribution?: boolean;
  isAdvantage?: boolean;
  itemProblem: ReviewAnalysis.ItemProblem;
  onUpdate: (problem: ReviewAnalysis.Problem[]) => void;
}) {
  const { t } = useTranslate();

  const { itemData, problemList } = itemProblem;

  const [newProblemOnly, setNewProblemOnly] = useState(false);

  const dataSource = useMemo(() => {
    return newProblemOnly ? problemList.filter(({ isNewProblem }) => isNewProblem) : problemList;
  }, [newProblemOnly, problemList]);

  return (
    <Modal
      title={isAdvantage ? t('优点明细') : t('问题明细')}
      width={980}
      footer={false}
      {...otherProps}
    >
      <Container>
        <Item item={itemData} />
        <header>
          {isAdvantage ? t('仅看新优点') : t('仅看新问题')}
          <Switch checked={newProblemOnly} onChange={setNewProblemOnly} />
        </header>
        <section>
          <ProblemTable
            dataSource={dataSource}
            pagination={false}
            isVoice={isVoice}
            isItemDistribution={isItemDistribution}
            isAdvantage={isAdvantage}
            item={itemData}
            onUpdate={onUpdate}
          />
        </section>
      </Container>
    </Modal>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 104px);
  > header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 0;
    > .ant-switch {
      margin-left: 4px;
    }
  }
  > * {
    flex: 0 0 auto;
  }
  > section {
    flex: 1 0 0;
  }
`;

export default ItemProblemModal;
